<template>
    <a-card hoverable style="width: 200px">

        <img slot="cover"
             :src="imageUrl"
        />

        <a-card-meta :title="itemName"
                     :description="getPrice"
        >

        </a-card-meta>

    </a-card>
</template>

<script>
export default {

    props : {
        itemId : {
            type : String,
            //required : true
        },
        itemName : {
            type : String,
            //required : true
        },
        itemPrice : {
            type: Number
        },
        categoryName : {
            type : String,
            //required : true
        },
        imageUrl : {
            type: String,
            //required: true
        },
        tax : { 
            type : Number,
            //required : true
        }

    },
    computed : {
        getPrice () {
            return this.itemPrice + ' kr'
        } 
    }
}
</script>

<style>

</style>